import { Select } from "antd";
import _ from "lodash";
import React from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

export const FormCreate = ({
  setDataList = () => undefined,
  locationOptions = [],
  customerOptions = [],
  setIsModalVisible,
  dataList,
  userProfile,
}) => {
  const allCustomers = getUserExtraCustomers();

  // console.log("customerOptions :>> ", customerOptions);
  const user_type = _.get(userProfile, ["user_type"]);
  const customerId = _.get(userProfile, ["category_customer_id"]);
  console.log("customerId :>> ", customerId);
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      category_customer_id: customerId,
    },
  });

  const selectedCustomer = useWatch({
    control,
    name: "category_customer_id",
  });

  const onHandleCreate = async (data) => {
    // customerId

    const name = _.get(data, ["name"]);
    const location_id = _.get(data, ["location_id"]);
    const categoryCustomerId = _.chain(locationOptions)
      .find((item) => {
        return item?.value === location_id;
      })
      .thru((item) => {
        return _.isNil(customerId)
          ? _.get(data, ["category_customer_id"])
          : item?.category_customer_id;
      })
      .value();
    console.log("categoryCustomerId :>> ", categoryCustomerId);
    // const category_customer_id = _.get(data, ["category_customer_id"]);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/building-create",
      isAuth: true,
      data: {
        name,
        category_customer_id: categoryCustomerId,
        location_id,
      },
    });

    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      toast.success("Create Building Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      const updateData = _.chain(dataList)
        .thru((list) => {
          return [results, ...list];
        })
        .map((item, index) => {
          return { ...item, key: index + 1, index: index + 1 };
        })
        .value();
      setDataList(updateData);
    }
  };

  const filteredLocationOptions = selectedCustomer
    ? _.filter(locationOptions, (location) => {
        const categoryCustomerId = _.get(location, ["category_customer_id"]);
        if (_.isNil(customerId)) {
          return location.category_customer_id === selectedCustomer;
        } else {
          return _.includes(allCustomers, categoryCustomerId);
        }
      })
    : null;

  console.log("filteredLocationOptions :>> ", filteredLocationOptions);

  const onHandleCustomerChange = (value) => {
    setValue("location_id", null); // Reset location_id
    setValue("category_customer_id", value);
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleCreate)} autoComplete="off">
      <Line />
      <InnerContainer>
        <div>
          <Controller
            name="name"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Name
                </Text>
                <StyledInput
                  label="name"
                  {...field}
                  size="large"
                  placeholder="name"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          {user_type !== "CUSTOMER" && (
            <Controller
              name="category_customer_id"
              control={control}
              rules={_.get(VALIDATE_RULES, ["required"])}
              render={({ field, fieldState: { error } }) => (
                <div>
                  <Text
                    color={COLOR_DARK}
                    fontSize="14px"
                    style={{ marginBottom: 4, marginLeft: 4 }}
                  >
                    Customer
                  </Text>
                  <Select
                    {...field}
                    size="large"
                    showSearch
                    placeholder="Select a customer"
                    optionFilterProp="children"
                    style={{ width: "100%" }}
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={customerOptions}
                    onChange={(value) => {
                      onHandleCustomerChange(value);
                      field.onChange(value);
                    }}
                  />
                  <ErrorValidate justify="start" error={error} />
                </div>
              )}
            />
          )}

          <Controller
            name="location_id"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Location
                </Text>
                <Select
                  disabled={
                    _.isNil(selectedCustomer) ||
                    _.isEmpty(filteredLocationOptions)
                  }
                  {...field}
                  size="large"
                  showSearch
                  placeholder="Select a location"
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={filteredLocationOptions}
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
        </div>

        <ButtonContainer>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
